import request from '@/utils/request'

export default {
  getStudentList(page, size, keyword) {
    return request.get('/student/list', {
      params: { page, size, keyword }
    })
  },

  getStudentById(id) {
    return request.get(`/student/${id}`)
  },

  addStudent(studentData) {
    return request.post('/student/add', studentData)
  },

  updateStudent(studentData) {
    return request.put('/student/update', studentData)
  },

  deleteStudent(id) {
    return request.delete(`/student/${id}`)
  }
}
